'use strict';

import { findWorkspaceRoot } from './core';

export = findWorkspaceRoot;
